import { clone, mergeRight, map } from 'ramda'

const replaceGroupKeys = (group) => {
  const reassignObjectProperties = (filter) => {
    filter['segmentProperty'] = filter.property

    delete filter.property

    filter['segmentValue'] = filter.value

    delete filter.value

    return filter
  }

  group.filters = map(reassignObjectProperties, group.filters)

  return group
}

export const queryTranslator = (esQuery, previousQuery) => {
  const queryCopy = clone(esQuery)

  const { ruleSet } = queryCopy

  delete queryCopy.ruleSet

  const flattenedQuery = mergeRight(queryCopy, ruleSet)

  flattenedQuery.name = flattenedQuery.name ? flattenedQuery.name : ''

  flattenedQuery['segmentGroups'] = flattenedQuery.groups

  delete flattenedQuery.groups

  flattenedQuery.segmentGroups = map(replaceGroupKeys, flattenedQuery.segmentGroups)

  return flattenedQuery
}